import { useCookies } from 'react-cookie';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import FadeIn from "react-fade-in/lib/FadeIn"
import { getCurrentRole, getStyle, getStepRedux, setStepRedux } from "../../libs/todoSlice";
import LoadingComponent from "../../lib/LoadingComponent";
import { getLoadingRedux, setLoadingRedux } from "../../libs/manageMemberSlice";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CreateIcon from '@mui/icons-material/Create';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Swal from "sweetalert2";
import fontColor from "../../lib/fontColor";
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Card, Table, Empty, Radio, Space, Input, Typography, Dropdown, Menu } from 'antd';
import { Row, Col } from 'react-bootstrap';
import { UserOutlined, MailOutlined, SwitcherOutlined, CloudDownloadOutlined, DatabaseOutlined, LockOutlined, UnorderedListOutlined } from '@ant-design/icons';
import EmailSMTP from './EmailSMTP';
import EmailTemplate from './EmailTemplate';


const HomeEmail = () => {
    const [cookie, setCookie, removeCookie] = useCookies(['account'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const [step, setStep] = useState('home');
    const [value, setValue] = useState('1');

    useEffect(() => {
        
    }, [cookie,step]);

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => {
        dispatch(setLoadingRedux({
        loading: action
        }))
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


  return (<FadeIn>

    <Row>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                TabIndicatorProps={{
                  sx: !!style.secondary_color && {
                    backgroundColor: `${style.secondary_color} !important`,
                    color: fontColor(style.primary_color)
                  }
                }}>
                <Tab label="ตั้งค่า SMTP อีเมล" value="1" />
                <Tab label="ตั้งค่า TEMPLATE อีเมล" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
                <EmailSMTP />
            </TabPanel>
            <TabPanel value="2">
                <EmailTemplate />
            </TabPanel>
          </TabContext>
        </Box>
    </Row>

  </FadeIn>
  )

}

export default HomeEmail